import { getDatabaseNamePath } from "../config/config";
import { post } from "./base";

export function getAll(accessToken, postData) {
  return post("file/GetFiles", { jsonBody: { accessToken, ...postData } });
}

export function getFilesOnDisk(accessToken, postData) {
  console.log(accessToken, postData);
  return post("file/GetFilesOnDisk", { jsonBody: { accessToken, ...postData } });
}

export async function add(formData) {
  // data: FormData -> remember to add accessToken
  
  if (!formData.get("name")) {
    formData.set("name", formData.get("file").name);
  }

  // Debug log per verificare il contenuto del FormData
  // for (var pair of formData.entries()) {
  //   console.log(pair[0]+ ', ' + pair[1]); 
  // }

  await post("file/AddFile", { accessToken: formData.get("accessToken"), formBody: formData });
  console.log(`File "${formData.get("name")}" added`);
}

export async function edit(accessToken, idFile, name, idAgente, type, variant) {
  await post("file/EditFile", { jsonBody: { accessToken, idFile, name, idAgente, type, variant } });
  console.log(`File ${idFile} edited`);
}

export async function remove(accessToken, idFile) {
  await post("file/DeleteFile", { jsonBody: { accessToken, idFile } });
  console.log(`File ${idFile} deleted`);
}

// export function download(accessToken, idFile, securedPath) {
//   return get("file/DownloadFile", { jsonBody: { accessToken, idFile, securedPath } });
// }

export function downloadOld(accessToken, idFile, securedPath) {
  const params = new URLSearchParams();
  params.append('accessToken', accessToken);
  params.append('idFile', idFile);
  params.append('path', getDatabaseNamePath());
  if (securedPath) params.append('securedPath', securedPath);

  // Apri direttamente il link → non usare fetch!
  window.location.href = window.location.protocol + '//' + window.location.hostname + '/inc/api/file/DownloadFile.php?' + params.toString();
  // return post("file/DownloadFile", { jsonBody: { accessToken, idFile, securedPath } })
  
}

export async function download(accessToken, idFile, securedPath, goToUrl = true) {
  try {
    let prefixUrl = window.location.protocol + '//' + window.location.hostname;
    let path = getDatabaseNamePath();
    // 1. Richiedi un token di download temporaneo
    const response = await fetch(prefixUrl + '/inc/api/file/CreateDownloadToken.php?path=' + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        accessToken,
        idFile,
        securedPath,
      }),
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.error || 'Errore nella generazione del link di download');
    }

    // 2. Reindirizza al download usando SOLO il token (nessun accessToken in URL!)
    const url = new URL(prefixUrl + '/inc/api/file/DownloadFile.php?path=' + path);
    url.searchParams.set('token', result.downloadToken);

    if (goToUrl) window.location.href = url.toString();
    return url.toString();
  } catch (err) {
    console.error('Download fallito:', err);
    alert('Impossibile avviare il download: ' + err.message);
  }
}